import React, { FormEvent, useState } from 'react';

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API_BASE = isLocalhost ? 'http://localhost:5000' : '';

const ForgotPasswordPage: React.FC = () => {
  const [identifier, setIdentifier] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [resetToken, setResetToken] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setMessage('');
    setError('');
    setResetToken('');
    setIsSubmitting(true);

    try {
      const response = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier }),
      });
      const payload = await response.json();
      if (!response.ok) {
        throw new Error(payload.error || 'Anfrage fehlgeschlagen');
      }
      setMessage(payload.message || 'Wenn der Account existiert, wurde ein Reset erstellt.');
      if (typeof payload.reset_token === 'string') {
        setResetToken(payload.reset_token);
      }
    } catch (submitError: any) {
      setError(submitError.message || 'Anfrage fehlgeschlagen');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="min-h-screen bg-amber-50 px-6 py-16 text-stone-900">
      <div className="mx-auto max-w-xl rounded-3xl border border-amber-200 bg-white p-8 shadow-sm">
        <p className="text-sm uppercase tracking-[0.35em] text-amber-700">Auth</p>
        <h1 className="mt-3 text-3xl font-semibold">Passwort vergessen</h1>
        <p className="mt-3 text-sm leading-6 text-stone-600">
          Gib deinen Username ein. Im Dev-Modus wird der Reset-Token direkt angezeigt.
        </p>

        <form className="mt-8 space-y-4" onSubmit={handleSubmit}>
          <label className="block">
            <span className="mb-2 block text-sm font-medium">Username</span>
            <input
              className="w-full rounded-2xl border border-stone-300 bg-white px-4 py-3 outline-none transition focus:border-stone-900"
              value={identifier}
              onChange={(event) => setIdentifier(event.target.value)}
              autoComplete="username"
              required
            />
          </label>

          {message ? <p className="text-sm text-emerald-700">{message}</p> : null}
          {error ? <p className="text-sm text-red-600">{error}</p> : null}
          {resetToken ? (
            <div className="rounded-2xl bg-amber-100 px-4 py-3 text-sm text-amber-950">
              Reset-Token: <code>{resetToken}</code>
            </div>
          ) : null}

          <button
            className="w-full rounded-2xl bg-amber-600 px-4 py-3 text-sm font-medium text-white transition hover:bg-amber-500 disabled:cursor-not-allowed disabled:bg-amber-300"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sende...' : 'Reset anfordern'}
          </button>
        </form>
      </div>
    </main>
  );
};

export default ForgotPasswordPage;
